import React from 'react';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import {Styles} from './Styles';
import {Play} from './Inc';
import Ajax from './Ajax';

interface Props {
    uid:string,
    play:Play,
    move(str:string):void,
}

const Death = (props:Props)=> {
    Ajax.setUid(props.uid);
    const classes = Styles.base();
    const next = ()=>{
        props.move("tweet");
    }

    let mes = "";

    if( props.play.water===0 ){
        mes = "乾いた喉が音をたてて割れた";
    } else if( props.play.magenta===100 && props.play.cyan===100 && props.play.yellow===100 ) {
        mes = "目の奥が焼き切れて暗くなった";
    } else if( props.play.magenta===100 && props.play.cyan===100 ) {
        mes = "空気が青いブヨブヨとしたゼリーに変わる";
    } else if( props.play.cyan===100 && props.play.yellow===100 ) {
        mes = "身体が緑のコケに覆われていく";
    } else if( props.play.magenta===100 && props.play.yellow===100 ) {
        mes = "刃と化した血が体を内側から引き裂く";
    } else if( props.play.magenta===100 ) {
        mes = "呂律がまわらなくなってきた";
    } else if( props.play.cyan===100 ) {
        mes = "知らない国の雨の音が聞こえる";
    } else if( props.play.yellow===100 ) {
        mes = "囁く声が「黄色は注意」と告げる";
    } else {
        mes = "";
    }

    return (
		<div id="death" className={classes.mainRoot}>
            <div className={classes.boardPlate}>
                死
            </div>
            <div className={classes.story}>
                {mes}<br/>
                {props.play.name}はベッドにたどり着き、<br/>
                ニッと笑って息絶えた<br/>
            </div>
            <AppBar position="fixed" color="primary" style={{position:"fixed",bottom:"0",top:"auto",lineHeight:"1em"}}>
                <Toolbar style={{padding:"0"}}>
                    <Button variant="text" color="default" onClick={next} style={{color:"white",width:"100%"}}>OK</Button>
                </Toolbar>
            </AppBar>
		</div>
	);
}

export default Death;
